if (!customElements.get('m-gmaps')) {
  class MGoogleMaps extends HTMLElement {
    constructor() {
      super();
      this.mapElement = this.querySelector('.m-gmaps__inner');
      this.initialized = false;
    }

    connectedCallback() {
      if (!this.mapElement || this.initialized) return;
      this.loadGoogleMaps()
        .then(() => this.initializeMap())
        .catch(() => this.classList.add('m-gmaps--error'));
    }

    loadGoogleMaps() {
      if (window.google && window.google.maps) return Promise.resolve();

      if (!window.luminexGoogleMapsPromise) {
        window.luminexGoogleMapsPromise = new Promise((resolve, reject) => {
          const existingScript = document.querySelector('script[data-luminex-google-maps]');
          if (existingScript) {
            existingScript.addEventListener('load', resolve, { once: true });
            existingScript.addEventListener('error', reject, { once: true });
            return;
          }

          const script = document.createElement('script');
          script.dataset.luminexGoogleMaps = 'true';
          script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(this.mapElement.dataset.key);
          script.async = true;
          script.addEventListener('load', resolve, { once: true });
          script.addEventListener('error', reject, { once: true });
          document.body.appendChild(script);
        });
      }

      return window.luminexGoogleMapsPromise;
    }

    initializeMap() {
      if (this.initialized || !window.google || !window.google.maps) return;

      const position = {
        lat: Number.parseFloat(this.mapElement.dataset.mapX),
        lng: Number.parseFloat(this.mapElement.dataset.mapY)
      };
      const zoom = Number.parseInt(this.mapElement.dataset.mapZoom, 10) || 16;
      const title = this.mapElement.dataset.mapTitle || '';

      this.map = new google.maps.Map(this.mapElement, {
        zoom,
        center: position,
        draggable: true,
        clickableIcons: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        disableDefaultUI: false
      });

      new google.maps.Marker({
        map: this.map,
        position,
        title
      });

      window.addEventListener('resize', () => {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(position);
      });

      this.initialized = true;
    }
  }

  customElements.define('m-gmaps', MGoogleMaps);
}
